import type { AppStore } from "~/app/store";
import { beginSessionExpiration } from "~/features/auth/session/beginSessionExpiration";
import { getSessionUserSnapshot } from "~/domains/user/sessionRuntime";

let appStore: AppStore | undefined;

export function initializeSessionExpiration(store: AppStore): void {
  appStore = store;
}

/** Shows the expiry UI immediately and logs out without reloading. */
export function triggerSessionExpired(): void {
  if (!appStore) {
    throw new Error("Session expiration is not initialized at the application composition root.");
  }

  // SCHAEFF-41833: the expiry signal fires for every terminal OCC 401 —
  // including the anonymous one a login-only page-data endpoint answers to
  // a visitor without a login (manual logout reload or public deep-link).
  // That visitor gets the homepage redirect instead; the expiry popup is
  // only meaningful for a visitor who was logged in when the session died.
  // A reload after the session already died is indistinguishable from a
  // never-logged-in visitor; silence is accepted. Known transient
  // suppression windows where uid is briefly absent for a logged-in
  // visitor: the account-context switch (SetAccount) and the punchout
  // token adoption (punchoutContinuation).
  if (!getSessionUserSnapshot()?.uid) {
    return;
  }

  const store = appStore;
  if (store.getState().sessionExpiration.phase !== "active") {
    return;
  }

  void beginSessionExpiration(store.dispatch);
}
